export default "__VITE_ASSET__5f5309d7__"